import { ExtendsMainComponent } from '../extends/extends-main.component';

import { SignInComponent } from './sign-in.component';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { WaitModalComponent } from '../wait-modal/wait-modal.component';
import { Router } from '@angular/router';

import { SignInService } from '../../service/sign-in.service';
import { TokenManager } from '../../service/web-api.service';
import { WebApiService } from '../../service/web-api.service';
import { DisplayService } from '../../service/display.service';

import { AuthService } from '../../service/auth.service';
import { environment } from '../../../environments/environment';
declare let gtag: any; // グローバル変数gtagを解決

export class SignInMainComponent extends ExtendsMainComponent {

  private waitModal: WaitModalComponent;
  private signInComponent: SignInComponent;
  private signInService: SignInService;

  private authService: AuthService;

  // 画面項目定義
  public userId: string;
  public password: string;
  public messages: any;

  public dispZ0001: string;
  public dispO0101: string;

  public passDispType: string;

  init(_signInComponent: SignInComponent, _signInService: SignInService,
    _authService: AuthService, _waitModal: WaitModalComponent) {

    this.config();

    this.signInComponent = _signInComponent;
    this.signInService = _signInService;
    this.authService = _authService;
    this.waitModal = _waitModal;

    this.userId = this.signInComponent.userId;
    this.password = this.signInComponent.password;
    this.messages = [];
    this.dispO0101 = this.signInComponent.dispO0101;
    this.dispZ0001 = this.signInComponent.dispZ0001;

    this.passDispType = 'password';
  }

  /**
   * イベント：次へ
   *
   */
  next(addNum?: number) {

    // 引継ぎ項目
    this.signInComponent.userId = this.userId.trim();
    this.signInComponent.password = this.password;
    if (addNum && addNum > 0) {
      this.signInComponent.pageNo += addNum;
    } else {
      this.signInComponent.pageNo++;
    }

    // 画面切り替え
    this.signInComponent.directInjection();
  }


  /**
   * イベント：戻る
   */
  back(subNum?: number) {
    // 引継ぎ項目
    if (subNum && subNum > 0) {
      this.signInComponent.pageNo -= subNum;
    } else {
      this.signInComponent.pageNo--;
    }
    // 画面切り替え
    this.signInComponent.directInjection();
  }

  /**
   * イベント：アカウント作成画面遷移
   */
  toSignUp() {
    this.signInComponent.router.navigate(['sign-up']);
  }

  /**
   * イベント：パスワードリセット画面遷移
   */
  toResetPassword() {
    this.signInComponent.router.navigate(['reset-password']);
  }


  /**
    * ログインボタン押下処理
    */
  login() {
    this.messages = [];
    this.waitModal.showModal();
    this.userId = this.userId.trim();
    this.signInService.execAuthenticate(this.userId, this.password).subscribe(result => {
      this.waitModal.hideModal();
      // 正常終了時はログイン処理を継続し、
      // エラー発生時はメッセージを表示する。
      if (result == null) {
        this.messages = [];
        // GAで集計する
        gtag('event', 'login');
        if (this.authService.isV2) {
          this.locationAssign('/oauth/v2/authorization/issue?' + TokenManager.getToken());
        } else {
          this.locationAssign('/oauth/authorization/issue?' + TokenManager.getToken());
        }
      } else {
        this.messages = result;
        this.scrollError('login_error', result);
      }
    });
  }

  /**
    * パスワードの表示・非表示を切り替える
    */
  switchPassDisp() {
    // 表示する
    if (this.passDispType === 'password') {
      this.passDispType = 'text';
      return;
    }
    // 非表示にする
    if (this.passDispType === 'text') {
      this.passDispType = 'password';
      return;
    }
  }
}
